export const validateLink = link => {
  // checking that there is an enabled configuration to validate
  if (Object.keys(link.options).length == 0) return true

  let isConfigured
  switch (link.slug) {
    case 'adobe-analytics':
      isConfigured = validateAA(Object.values(link.options))
      break
    case 'google-analytics':
      isConfigured = validateGA(Object.values(link.options))
      break
    case 'facebook':
      isConfigured = validateFB(Object.values(link.options))
      break
    default:
      isConfigured = validateGeneral(Object.values(link.options))
  }
  return isConfigured
}

const validateGeneral = options => {
  const validOptions = options.filter(option => option.enabled || option.slug.includes('exists'))

  if (validOptions.length) {
    // checking that at least one of the options return true from being validated
    // as of now general validations have a max of two options which is why this works, if a validation adds options or complexity to an option
    // it will need its own validate functionality
    return (
      validOptions
        .map(option => {
          if (option.slug.includes('exists')) {
            return true
          }
          return Object.keys(option.metadata).length !== 0
        })
        .filter(i => i !== false).length > 0
    )
  }
  return false
}

const validateFB = options => {
  const validOptions = options.filter(option => option.enabled || option.slug === 'fb_pixel_exists')

  if (validOptions.length) {
    // checking that none of the valid options return false from being validated
    return (
      validOptions
        .map(option => {
          let isValid
          switch (option.slug) {
            case 'fb_pixel_correct_id':
              isValid = validateFBProperty(option.metadata)
              break
            case 'fb_pixel_exists':
              isValid = true
              break
          }
          return isValid
        })
        .filter(i => i == false).length == 0
    )
  }
  return false
}

const validateFBProperty = data => {
  // verify that the property id has a value
  if (Object.keys(data).length) {
    if (data.expected_property_id && data.expected_property_id.trim() !== '') {
      return true
    }
    return false
  }
  return false
}

const validateGA = options => {
  const validOptions = options.filter(option => option.enabled || option.slug === 'ga_pixel_exists')

  if (validOptions.length) {
    // checking that none of the valid options return false from being validated
    return (
      validOptions
        .map(option => {
          let isValid
          switch (option.slug) {
            case 'ga_correct_property':
              isValid = validateGAProperty(option.metadata)
              break
            case 'ga_pixel_exists':
              isValid = true
              break
          }
          return isValid
        })
        .filter(i => i == false).length == 0
    )
  }
  return false
}

const validateGAProperty = data => {
  // verify that the target id or the property id have a value
  if (Object.keys(data).length) {
    if (data.expected_target_id) {
      return true
    }
    if (data.expected_property_id && data.expected_property_id.trim() !== '') {
      return true
    }
    return false
  }
  return false
}

const validateAA = options => {
  const validOptions = options.filter(option => option.enabled || option.slug === 'aa_pixel_exists')

  if (validOptions.length) {
    // checking that none of the valid options return false from being validated
    return (
      validOptions
        .map(option => {
          let isValid
          switch (option.slug) {
            case 'aa_correct_report':
              isValid = validateAAReport(option, validOptions)
              break
            case 'aa_correct_report_suite':
              isValid = validateAASuite(option.metadata)
              break
            case 'aa_pixel_exists':
              isValid = true
              break
          }
          return isValid
        })
        .filter(i => i == false).length == 0
    )
  }
  return false
}

const validateAASuite = data => {
  // verify that either the report suite id or the target id have a value
  if (data.expected_report_suite_id && data.expected_report_suite_id.trim() !== '') {
    return true
  }
  if (data.expected_target_id) {
    return true
  }
  return false
}

const validateAAReport = (data, options) => {
  const reportSuite = options.filter(v => v.slug === 'aa_correct_report_suite')[0]
  if (reportSuite && reportSuite.metadata) {
    if (reportSuite.metadata.expected_report_suite_id) {
      // if the report suite id is set validate that the report id is also set
      return !!(Object.keys(data.metadata).length > 0 && data.metadata.expected_report_id)
    }
    return data.enabled !== false
  }
  return false
}
